import React from "react";
import { Icon } from '@iconify/react';
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();
  
  // Get path segments
  const pathnames = location.pathname.split("/").filter(x => x);
  
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
      <h6 className="fw-semibold mb-0" style={{textTransform:'capitalize'}}>{pathnames[pathnames.length - 1] || "Dashboard"}</h6>
      <ul className="d-flex align-items-center gap-2">
        <li className="fw-medium">
          <Link style={{textTransform:'capitalize'}} to="/" className="d-flex align-items-center gap-1 hover-text-primary">
            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
              Dashboard
          </Link>
        </li>

        {pathnames.length > 0 && <li> - </li>}

        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <li key={routeTo} className="fw-medium">
              {!isLast ? (
                <Link style={{textTransform:'capitalize'}} to={routeTo} className="hover-text-primary">
                  {name.charAt(0).toUpperCase() + name.slice(1)}
                </Link>
              ) : (
                <span style={{textTransform:'capitalize'}}>{name.charAt(0).toUpperCase() + name.slice(1)}</span>
              )}
              {!isLast && <span> - </span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Breadcrumb;
